import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer, Image } from '@mafc/trolly';

import BankDiscountFailed from 'assets/insert-credit-card.png';
import DiscountFailed from 'assets/cancelled.png';
import PlaceOrderErrorHeader from './CreateOrderErrorHeader';
import usePlaceOrderErrors from '../hooks/usePlaceOrderError';

import * as S from './CreateOrderError.style';

const CreateOrderError: React.FC = () => {
  const { t } = useTranslation();

  const {
    errorCode,
    isOpen,
    isBankDiscountFailed,
    isDiscountFailed,
    openDrawer,
    closeDrawer,
  } = usePlaceOrderErrors();

  useEffect(() => {
    if ((isBankDiscountFailed || isDiscountFailed) && !isOpen) {
      openDrawer();
    }
  }, [isBankDiscountFailed, isDiscountFailed, isOpen, openDrawer]);

  return isOpen ? (
    <Drawer
      anchor={['bottom', null, 'right']}
      isOpen={isOpen}
      title={<PlaceOrderErrorHeader errorCode={errorCode} />}
      variant="float"
      containerStyles={{
        borderTopLeftRadius: [4, null, null, 0],
        borderTopRightRadius: [4, null, null, 0],
      }}
      isTitleBorder={false}
      contentStyles={{ pt: 1, borderRadius: '20px', textAlign: 'center' }}
      width={[null, null, '480px']}
      data-testid="place-order-error"
      preventCloseOnClickOutside
      closeOnEsc={false}
    >
      {isDiscountFailed && (
        <>
          <Image url={DiscountFailed} name="discount-failed" height="240px" width="auto" />
          <S.ErrorMessage>{t('createOrderError.discountFailedMessage')}</S.ErrorMessage>
        </>
      )}

      {isBankDiscountFailed && (
        <>
          <Image url={BankDiscountFailed} name="bank-discount-failed" height="240px" width="auto" />
          <S.ErrorMessage>{t('createOrderError.bankDiscountFailMessage')}</S.ErrorMessage>
        </>
      )}

      <S.TryAgainButton onClick={closeDrawer} variant="secondary" preventTextTransform>
        {t('createOrderError.tryAgain')}
      </S.TryAgainButton>
    </Drawer>
  ) : (
    <></>
  );
};

export default CreateOrderError;
